import { Injectable } from '@angular/core';

import { DocumentMulti } from './document-multi';

@Injectable({
  providedIn: 'root'
})
export class FullscreenToggleService {
  public constructor() { }

  public toggleFullScreen(): void {
    const isKeyboardAvailableOnFullScreen = typeof Element !== 'undefined'
      && 'ALLOW_KEYBOARD_INPUT' in Element
      && (Element as typeof Element & { ALLOW_KEYBOARD_INPUT: boolean }).ALLOW_KEYBOARD_INPUT;
    const element = document.documentElement as DocumentMulti;
    const toOpen = !(document.fullscreenElement || element.webkitFullscreenElement || element.mozFullScreenElement);
    if (toOpen) {
      if (element.requestFullscreen) {
        element.requestFullscreen().catch((error: unknown) => console.error(error));
      }
      else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen().catch((error: unknown) => console.error(error));
      }
      else if (element.webkitRequestFullscreen) {
        const safariVersionReg = /Version\/[\d]{1,2}(\.[\d]{1,2}){1}(\.(\d){1,2}){0,1} Safari/;
        if (safariVersionReg.test(navigator.userAgent)) {
          setTimeout(() => {
            element.webkitRequestFullscreen!().catch((error: unknown) => console.error(error));// Safari temporary fix
          });
        }
        else {
          element.webkitRequestFullscreen(isKeyboardAvailableOnFullScreen as any).catch((error: unknown) => console.error(error));
        }
      }
      else if (element.msRequestFullscreen) {
        element.msRequestFullscreen().catch((error: unknown) => console.error(error));
      }
    }
    else {
      const doc = document as Document & Pick<DocumentMulti, 'webkitExitFullscreen'>;
      if (document.exitFullscreen) {
        document.exitFullscreen().catch((error: unknown) => console.error(error));
      }
      else if (doc.webkitExitFullscreen) {
        doc.webkitExitFullscreen().catch((error: unknown) => console.error(error));
      }
    }
  }
}
